import React from 'react';

const ValuesDisplay = ({ chartData }) => (
  <section className="Values">
    <div>
      <p id="Value-title">TOTAL TRANSACTIONS</p>
      <p id="Value-Number">{chartData.totalTransactions}</p>
    </div>
    <div>
      <p id="Value-title">SERVICE DESK</p>
      <p id="Value-Number">{chartData.DbTransactions}</p>
    </div>
    <div>
      <p id="Value-title">LIB ANSWERS</p>
      <p id="Value-Number">{chartData.libAnswersTransactions}</p>
    </div>
  </section>
);

export default ValuesDisplay;
